import { render } from "./CnNotify.vue?vue&type=template&id=01b0989b&scoped=true"
import script from "./CnNotify.vue?vue&type=script&lang=js"
export * from "./CnNotify.vue?vue&type=script&lang=js"

import "./CnNotify.vue?vue&type=style&index=0&id=01b0989b&lang=scss&scoped=true"
import "./CnNotify.vue?vue&type=style&index=1&id=01b0989b&lang=scss"

import exportComponent from "D:\\work\\qianduan\\operation-system\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01b0989b"]])

export default __exports__